import { render, staticRenderFns } from "./FreeIndex.vue?vue&type=template&id=7990f4be&scoped=true"
import script from "./FreeIndex.vue?vue&type=script&lang=js"
export * from "./FreeIndex.vue?vue&type=script&lang=js"
import style0 from "./FreeIndex.vue?vue&type=style&index=0&id=7990f4be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7990f4be",
  null
  
)

export default component.exports